const rankingData = [
  { rank: 1, title: '剑尊归来', author: 'REDICE STUDIO', genre: '玄幻', status: '连载中', hot: '🔥 986万热度', update: '今日更新 第203话' },
  { rank: 2, title: '我独自升级', author: 'Chugong / DUBU', genre: '热血', status: '连载中', hot: '🔥 872万热度', update: '昨日更新 第179话' },
  { rank: 3, title: '女神降临', author: 'Yaongyi', genre: '恋爱', status: '连载中', hot: '🔥 765万热度', update: '今日更新 第156话' },
  { rank: 4, title: '全职高手', author: '蝴蝶蓝 / 常盘勇者', genre: '热血', status: '连载中', hot: '🔥 698万热度', update: '3天前更新 第421话' },
  { rank: 5, title: '反派千金', author: 'Gwon Gyeoeul', genre: '恋爱', status: '连载中', hot: '🔥 632万热度', update: '今日更新 第88话' },
  { rank: 6, title: '斗破苍穹', author: '天蚕土豆 / 任翔', genre: '玄幻', status: '连载中', hot: '🔥 587万热度', update: '昨日更新 第512话' },
  { rank: 7, title: '狐妖小红娘', author: '小新', genre: '恋爱', status: '连载中', hot: '🔥 541万热度', update: '今日更新 第389话' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-2">热门排行</h2>
          <p className="text-sm text-foreground-500">全网热度最高的漫画作品，每日更新推荐</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {rankingData.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className="group flex items-start gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors duration-200 no-underline"
            >
              <div className={`flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center font-black text-sm ${
                i === 0 ? 'bg-primary-500 text-background-50' :
                i === 1 ? 'bg-accent-500 text-background-50' :
                i === 2 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-bold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 text-[10px] px-1.5 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium">
                    {item.genre}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mb-1">{item.author}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{item.hot}</span>
                  <span className="text-xs text-foreground-400">{item.update}</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#ranking"
            onClick={(e) => e.preventDefault()}
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看完整排行榜 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}